/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { IncludeForm } from './include-form';


export interface TipoPraticaCloneForm { 
    codice: string;
    descrizione: string;
    comune_id_destinazione?: string;
    include?: IncludeForm;
}

